import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Realisations from "../components/Realisations";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Realisations);
const withTranslationComponent = withTranslation(["realisations", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/Realisations.js